import React from "react";
import moment from "moment";
import { ButtonToolbar, Glyphicon } from "react-bootstrap";

export const CustomToolbar = toolbar => {
  const goToBack = () => {
    toolbar.onNavigate("PREV");
  };
  const goToNext = () => {
    toolbar.onNavigate("NEXT");
  };
  const goToCurrent = () => {
    toolbar.onNavigate("TODAY");
  };

  const label = () => {
    const date = moment(toolbar.date);
    return (
      <span>
        <b>{date.format("MMMM")}</b>
        <span> {date.format("YYYY")}</span>
      </span>
    );
  };

  return (
    <div id="toolbar-container">
      <ButtonToolbar className="calendar-nav">
        <span className="rbc-btn-group">
          <button
            className="btn btn-primary btn-current pull-left"
            id="calendar-current-month"
            onClick={goToCurrent}
          >
            <Glyphicon glyph="calendar" />
            Today
          </button>
        </span>
        <span className="rbc-toolbar-label">
          <label id="calendar-display-month">{label()}</label>
        </span>
        <span className="rbc-btn-group">
          <button
            className="btn btn-primary btn-back"
            id="calendar-previous-month"
            onClick={goToBack}
          >
            <Glyphicon glyph="chevron-left" />
            Back
          </button>
          <button
            className=" btn btn-primary btn-next"
            id="calendar-next-month"
            onClick={goToNext}
          >
            Next
            <Glyphicon glyph="chevron-right" />
          </button>
        </span>
      </ButtonToolbar>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/calendar/CustomToolbar.js